// extracted by mini-css-extract-plugin
export default {"container":"ebM3K","squareImage":"_2kAxV","wideImage":"_2gI30"};